import { useTranslation } from 'react-i18next'

/**
 * Accessibility skip link — visually hidden until focused via Tab key.
 * Allows keyboard users to bypass the nav and jump directly to page content.
 * Must be the FIRST element in the DOM.
 */
export function SkipLink() {
  const { t } = useTranslation('common')

  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[9999] focus:px-4 focus:py-2 focus:bg-background focus:text-foreground focus:border focus:border-border focus:rounded-md focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ocean-500 font-sans text-sm font-medium"
    >
      {t('aria.skipToContent')}
    </a>
  )
}
